import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const PublicLandingLayout = lazy(() => import("src/modules/Landing/layouts/PublicLandingLayout"));
const CreateTaskExternalForShipping = lazy(() => import("src/_modules/Tasks/ShippingCompany/CreateTaskExternal"));
const ExternalCreateTask = lazy(() => import("src/_modules/Tasks/FreelanceDriver/ExternalCreateTask"));
const Survey = lazy(() => import("src/modules/Landing/views/Survey"));

const publicRoutes = () => (
    <>
        <Route path="public" element={<PublicLandingLayout />}>
            <Route path="survey" element={<Survey />} />
            <Route path="freelance_driver_task" element={<ExternalCreateTask />} />
            <Route path="create_task_for_shipping_company/:id" element={<CreateTaskExternalForShipping />} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default publicRoutes;
